export default async function displayRazorpay(callback) {
  const data = await fetch('http://localhost:1337/razorpay', {
    method: 'POST',
  }).then((t) => t.json());

  console.log(data);

  const options = {
    key: undefined,
    currency: data.currency,
    amount: 500,
    name: 'NPS YPR',
    description: 'Online Admission Process',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT72D_ch0DGqoFb-aIylOADqXmdyw9ktTDP9g&usqp=CAU',
    order_id: data.id,
    handler: function (response) {
      return callback(response);
    },
    prefill: {
      name: 'Poorvika',
      email: 'poorvika@gmail.com',
      contact: '9999999999',
    },
  };

  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
}
